import { credentials } from '@shootsta/client-auth';
import _uniq from 'lodash.uniq';
import { userColors } from './constants/userColors';

export const generateUserColors = ({ userIds }) => {
  const uniqueUserIds = _uniq(userIds);

  return uniqueUserIds.reduce((colorMap, userId, userIndex) => {
    const colorIndex = userIndex % userColors.length;
    const { color, darken } = userColors[colorIndex];
    const lightenFactor = 30 * Math.floor(userIndex / userColors.length);

    return {
      ...colorMap,
      [userId]: {
        color,
        brightness: darken ?
        `brightness(${100 - lightenFactor}%)` :
        `brightness(${100 + lightenFactor}%)`,
        darken
      }
    };
  }, {});
};

export const getUserColor = (
{ userAssignedColors = {}, userId }) =>
{
  const currentCredentials = { user: {}, ...credentials.get() };
  const currentUserId = userId || currentCredentials.user.userId;
  const userColor = userAssignedColors[currentUserId];

  if (userColor) return { userColor };

  const userIds = [...Object.keys(userAssignedColors), currentUserId];
  const updatedUserColors = generateUserColors({ userIds });

  return { userColor: updatedUserColors[currentUserId], updatedUserColors };
};